import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getTierCardStyles = (theme: Theme, highlighted: boolean) =>
  StyleSheet.create({
    card: {
      width: '100%',
      borderRadius: theme.border.large,
      borderWidth: highlighted ? theme.border.tiny : 1,
      borderColor: highlighted ? theme.colors.gold : theme.colors.grey20,
      backgroundColor: highlighted ? theme.colors.gold + '10' : theme.colors.white,
      paddingHorizontal: theme.spacing.xl,
      paddingVertical: theme.spacing.xl,
      gap: theme.spacing.sm,
      // A soft lift only on the recommended tier, so it reads as the primary
      // choice without an extra decorative element.
      shadowColor: theme.colors.black,
      shadowOpacity: highlighted ? 0.12 : 0,
      shadowRadius: highlighted ? 16 : 0,
      shadowOffset: { width: 0, height: 6 },
      elevation: highlighted ? 4 : 0,
    },
    badge: {
      position: 'absolute',
      top: -theme.spacing.md,
      right: theme.spacing.xl,
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.xs,
      backgroundColor: theme.colors.gold,
      paddingVertical: theme.spacing.xxs,
      paddingHorizontal: theme.spacing.md,
      borderRadius: 999,
    },
    title: {
      color: highlighted ? theme.colors.gold : theme.colors.black,
    },
    subtitle: {
      color: theme.colors.secondary,
    },
    price: {
      marginTop: theme.spacing.sm,
    },
    divider: {
      height: 1,
      backgroundColor: theme.colors.grey20,
      marginVertical: theme.spacing.md,
    },
    features: {
      gap: theme.spacing.md,
    },
    featureRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: theme.spacing.sm,
    },
    featureMarker: {
      width: theme.iconSize.small,
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: theme.spacing.xxs,
    },
    featureDot: {
      width: theme.spacing.sm,
      height: theme.spacing.sm,
      borderRadius: theme.spacing.sm / 2,
      backgroundColor: theme.colors.grey50,
    },
    featureText: {
      flex: 1,
      color: theme.colors.black,
    },
    ctaSlot: {
      marginTop: theme.spacing.lg,
    },
  })
